import { z } from '@harvestiq/zod';
import { safeUserSchema } from '../users/user';
import { dbEntitySchema } from './db-entity';

export const entitySchema = dbEntitySchema.extend({
  owner: safeUserSchema.nullable(),
  agent: safeUserSchema.nullable(),
  endorsementCount: z.number().default(0),
});

export type Entity = z.infer<typeof entitySchema>;

export type SearchableEntityFields = keyof Pick<
  Entity,
  'firstName' | 'lastName' | 'businessName' | 'email'
>;
